/*
** OpenAPI Client - CONTROLLER: NowController
*/
import request from 'superagent';
import { OpenAPI } from '..';
export var NowController;
(function (NowController) {
    function findMedia() {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await request
                    .get(OpenAPI.URL + '/now/find')
                    .set('Accept', 'application/json')
                    .withCredentials();
                resolve(response.body);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    NowController.findMedia = findMedia;
    function getNow() {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await request
                    .get(OpenAPI.URL + '/now/get')
                    .set('Accept', 'application/json');
                resolve(response.body);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    NowController.getNow = getNow;
    function getState() {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await request
                    .get(OpenAPI.URL + '/now/getState')
                    .set('Accept', 'application/json')
                    .withCredentials();
                resolve(response.body);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    NowController.getState = getState;
    function setDefaultState() {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await request
                    .post(OpenAPI.URL + '/now/setDefaultState')
                    .withCredentials();
                resolve(response.body);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    NowController.setDefaultState = setDefaultState;
    function setState(value) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await request
                    .post(OpenAPI.URL + '/now/setState')
                    .send(value)
                    .withCredentials();
                resolve(response.body);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    NowController.setState = setState;
})(NowController || (NowController = {}));
//# sourceMappingURL=now.js.map